<style lang="less" scoped>
  #informal-wage-excel-input{
    display: none;
  }
  .user-flow-base {
    display: inline-block;
    /deep/ div {
      display: inline-block;
      vertical-align: middle;
    }
  }
  .tips {
    width: 100%;
   // color: orange;
   color: #EF6C00;
     p {
      margin: 0px;
   
     // text-indent: 2em;
    }
  }
</style>
<template>
  <div>
    <div class="line">
      <h1>
        {{ topic.wage_month }}
        {{ topic.name }}
        从 {{ topic.wage_start }}(含) 到 {{ topic.wage_end }}(含)
        <small>
          (共 {{ records.length }} 条记录)
        </small>
      </h1>
    </div>
    <div
      v-if="!is_reissue"
      class="tips"
    >
      <h4>填写说明：</h4>
      <p>
        “计薪天数（远程+现场）”和“餐补天数”跟据实习生同学实际打卡情况进行系统自动抓取和统计，不支持手动修改。
      </p>
      <p>如果因错过补卡时间等原因导致“计薪天数（远程+现场）”和“餐补天数”确实需要修改，leader可以在“其他发放”内填写调整金额并备注好调整原因。</p>
      <p>请督促实习生同学每天按时打卡；如果有异常，及时处理打卡异常。</p>
    </div>
    <div
      v-if="is_reissue"
      class="tips"
    >
      <h4>填写说明：</h4>
      <p>
        若确认需补发实习生津贴/餐补，可手动在“计薪天数（远程+现场）”或“餐补天数”进行填写。
      </p>
      <p>请督促实习生同学每天按时打卡；如果有异常，及时处理打卡异常。</p>
    </div>
    <div
      v-if="director_topic.user_flow"
      class="line"
    >
      <div
        v-if="!director_topic.del"
        style="display:inline-block"
      >
        <UserFlowBase
       
          class="user-flow-base"
          :show_others="false"
          :user_flow="director_topic.user_flow"
          :model="director_topic"
          :submit-disabled="is_exceed_days || is_exceed_subsidy_days"
        />
        <span
          v-if="is_exceed_days"
          style="margin-left:10px"
          class="color-error"
        >[{{ is_exceed_days.join('、') }}-记薪天数超过当月自然日天数({{ wages_days }}天)]</span>
        <span
          v-if="is_exceed_subsidy_days"
          style="margin-left:10px"
          class="color-error"
        >[{{ is_exceed_subsidy_days.join('、') }}-餐补发放天数超过当月自然日天数({{ wages_days }}天)]</span>
      </div>
      <span v-else>
        <span class="color-error">已废弃</span>
        <Button
          size="large"
          type="primary"
          @click="recoverDirectorTopic"
        >恢复填写</Button>
      </span>
      <Button
        v-if="show_del_btn"
        size="small"
        @click="deleteDirectorTopic"
      >
        放弃本次发放
      </Button>
      <span
        v-if="!can_edit"
        class="color-warning"
        style="padding-left: 10px"
      >未提交状态才能编辑</span>
      <!--保存 隐藏不显示-->
      <Ajaxbtn
        v-show="false"
        ref="saveBtn"
        :url="update_records_url"
        :params="save_params"
        :config="save_btn_config"
        @done="saveDone"
        @fail="saveFail"
      />
      <!--excel导入-->
      <span
        v-if="can_edit"
        class="float-right"
        style="margin-left:10px"
      >

        <Button
          style="margin-right:10px"
          size="small"
          icon="ios-download-outline"
          type="primary"
          @click="exportTempt"
        >导出实习生发薪模板</Button>
        <Button
          style="margin-right:10px"
          size="small"
          type="primary"
          @click="importxz"
        >导入实习生薪资</Button>
        <Button
          size="small"
          icon="ios-download-outline"
          type="primary"
          @click="exportData"
        >导出考勤数据</Button>
      </span>

      <!-- <span
        v-if="can_edit"
        class="float-right"
      >
        <label
          class="ivu-btn ivu-btn-warning ivu-btn-small"
          for="informal-wage-excel-input"
        >
          <Icon type="md-cloud-upload" />
          导入数据
        </label>
      </span> -->
    </div>
  
    <div
      v-if="director_topic.id && !director_topic.user_flow"
      class="line"
    >
      状态:
      <span
        v-if="is_topic_finished"
        class="color-success"
      >
        已完成
      </span>
    </div>
    <div class="line">
      <input
        id="informal-wage-excel-input"
        ref="importInput"
        type="file"
        @focus="importFocus"
        @change="importInvoice"
      >
      <div
        v-show="import_processing"
        class="line"
      >
        <Progress
          :percent="import_percent"
          status="active"
        />
      </div>
    </div>
    <div class="list-container">
      <Table
        ref="table"
        :row-class-name="rowClassName"
        :columns="record_columns"
        :data="records"
        :loading="loading"
        no-data-text="暂无数据"
        size="small"
      />
      <Backdrop v-show="loading" />
    </div>
    <div style="display:flex">
      <div style="flex:1">
        <h3>
          实习生津贴发放规则
        </h3>
        <p style="margin:0px">
          长期远程办公：发放100%*日津贴标准
        </p>
        <p style="margin:0px">
          临时远程办公：发放80%*日津贴标准
        </p>
        <p style="margin:0px">
          上半天请假：发放70%*日津贴标准
        </p>
        <p style="margin:0px">
          下半天请假：发放30%*日津贴标准
        </p>
        <p style="margin:0px">
          全天请假：发放0%*日津贴标准
        </p>
        <p style="margin:0px">
          入职/离职当天：默认发放100%*日津贴标准
        </p>
      </div>
      <div style="flex:1">
        <h3>
          日津贴特殊数字说明
        </h3>
        <p style="margin:0px">
          基于算薪的情境，有几个日津贴特殊数字，特做以下对应场景说明：
        </p>
        <p style="margin:0px">
          0.8天：申请全天临时远程办公，上下班正常远程打卡
        </p>
        <p style="margin:0px">
          0.24天：上半天申请临时远程办公，下半天忘记打卡
        </p>
        <p style="margin:0px">
          0.56天：下半天申请临时远程办公，上半天忘记打卡
        </p>
        <p style="margin:0px">
          0.94天：上半天申请临时远程办公，下半天正常打卡
        </p>
        <p style="margin:0px">
          0.86天：下半天申请临时远程办公，上半天正常打卡
        </p>
        <p style="margin:0px">
          0.3天：下半天请假，上半天正常打卡
        </p>
        <p style="margin:0px">
          0.7天：上半天请假，下半天正常打卡
        </p>
      </div>
    </div>

    <br>
    <div class="line">
      <h2>我管理的员工 <small>共 {{ informals.length }} 人, 其中 {{ quit_count }} 人已离职.</small></h2>
    </div>
    <div
      v-if="can_select_user && can_edit"
      class="line text-right"
    >
      <span class="color-error">仅用于补充暑期实习生津贴 </span>
      <CustomerSelector
        style="width: 150px"
        :url="$util.api.query_informal_intern"
        @on-change="addCustomerToWageRecords"
      >
        选择员工
      </CustomerSelector>
    </div>
    <div class="list-container">
      <Button
        type="primary"
        style="margin-bottom:10px"
        :loading="get_cx_loading"
        @click="()=>{
          attendance_type = 'all'
          refreshAllAttendanceData()
        }"
      >
        全部考勤
      </Button>
      <Button
        type="primary"
        style="margin-left:10px;margin-bottom:10px"
        :loading="set_wage_loading || get_cx_loading"
        @click="addAllInternProxy"
      >
        一键添加所有实习生
      </Button>
      <!--  :no-data-text="informal_empty_tip" -->
      <Table
        ref="table"
        border
        :columns="informal_columns"
        :data="informals_computed"
        no-data-text="暂无数据"
        size="small"
      />
      <Backdrop v-show="isInformalLoading" />
      <div class="line">
        <span style="font-weight:bold">系统会自动保存您填写的数据， 请您填好名下所有实习生津贴后再提交。</span>
        <br>
        生成工资记录后, 更改用户的[银行信息][税前日薪]等不会自动同步到工资记录
        <br>
        如需同步到工资记录, 请在编辑状态下手动同步
      </div>
      <div
        v-if="get_cx_loading"
        class="line color-warning"
      >
        {{ attendance_loading_text || '正在获取实习生考勤信息，请稍候...' }}
      </div>
      <v-progress-linear
        v-if="get_cx_loading"
        color="primary"
        indeterminate
      />
      <Attendance 
        :list="attendance_list_proxy"
        :informals-hash="informals_hash"
        :from-date="topic.wage_start"
        :to-date="topic.wage_end"
      /> 
    </div>

    <RichText
      :url="save_desc_url"
      :params="edit_record"
      :config="rich_text_config"
      :text.sync="edit_record.desc"
      @close="closeEdit"
    />
    <!--   从 {{ topic.wage_start }}(含) 到 {{ topic.wage_end }}(含) -->
    
    <div style="height:0px;overflow:hidden">
      <DownloadTable 
        ref="DownloadTable"
        :date-arr="[topic.wage_start,topic.wage_end]"
        :list="attendance_list"
        :persons="informals"
      /> 
    </div>
    <div ref="contain" />
    <MyInformalWageRecordModal
      ref="recordModal"
      :is_reissue="is_reissue"
      @refresh="getMyInformalWageRecordsByTopic"
    />
  </div>
</template>
<script :route="{path: '/team/my_informal_wage_record/:id',noChkout: true}">
  import Util, { getsafe } from '../../libs/util';
  import FlowUtil from '../../libs/flow_util';
  import UserFlowBase from '../components/flow/user_flow_base';
  import CustomerSelector from '../components/customer/selector';
  import Attendance from './components/Attendance.jsx'
  import DownloadTable from './components/DownloadTable'
  import {mapGetters} from "vuex";
  import { hr_http } from '@/libs/util.js'
  import util from '@/libs/util'
  import { setBatchAddCustomerApi } from './service'
  import moment from 'moment'
  import { director_informal_wage_topic_export_template, importBatchApi } from '@/views/team/service.js';
  import MyInformalWageRecordModal from './my_informal_wage_record_modal.vue';
  const records_error = {
    company_id: '未指定公司',
    team_id: '未指定团队',
    bank: '未填写银行',
    bank_number: '未填写银行卡号'
  }
  const { 
    hr_wxdata_financial_intern_salary_of_customer_new,
  } = util.api || {}
  

  export default {
    /* router_info_start */
    router_info: {
      path: '/team/my_informal_wage_record/:id',
      noChkout: true
    },
    /* router_info_end */
    components: { UserFlowBase, CustomerSelector, Attendance, DownloadTable, MyInformalWageRecordModal },
    data() {
      return {
        add_type: 3,
        status_type: 3,
        get_cx_loading: false,
        set_wage_loading: false,
        attendance_list: [],
        attendance_type: null,
        attendance_loading_text: '',
        attendance_full_loaded: false,
        attendance_request: null,
        informals_loaded: false,
        topic_loaded: false,
        informals: [],
        records: [],
        adding: false,
        adding_customer_id: 0,
        topic: {},
        director_topic: {},
        
        // 获取列表时
        empty_tip: '暂无数据',
        informal_empty_tip: '获取数据中...',
        loading: false,
        isInformalLoading: false,
        edit_config: {
          modal: false,
          loading: true
        },
        save_btn_config: {
          size: 'small',
          type: 'warning',
          name: '保存',
          successedName: '保存成功',
          failedName: '保存失败',
        },
        update_records_url: Util.api.update_informal_wage_records,
        update_director_topic_status: Util.api.update_director_topic_status,
        import_processing: false,
        import_percent: 0,
        rich_text_config: {
          title: '',
          show: false
        },
        save_desc_url: Util.api.informal_wage_record_update_desc,
        edit_record: {},
      }
    },
    computed: {
      cur_customer() {
       
        return this.$store.state.cur_customer;
      },
      is_reissue() {
        return getsafe(this.topic, 'payment_batch') === 'reissue'
      },
      // 计薪天数超过
      is_exceed_days() {
        const go = []
        this.records.forEach(item => {
          const work_days = Number(item.work_days) || 0
          if (work_days > this.wages_days) {
            go.push(item.account)
            // go = true
          }
        })
        return go.length ? go : null
      },
      is_exceed_subsidy_days() {
        const go = []
        this.records.forEach(item => {
          const subsidy_days = Number(item.subsidy_days) || 0
          if (subsidy_days > this.wages_days) {
            go.push(item.account)
          }
        })
        return go.length ? go : null
      },
      record_columns() {
        return [
          {
            type: 'expand',
            title: '展开备注',
            align: 'center',
            fixed: 'left',
            width: 60,
            render: (h, params) => {
              const desc = params.row.desc;
              if (desc) {
                return h('div', {
                  domProps: {
                    innerHTML: desc
                  }
                });
              } else {
                return h('div', '备注: 无')
              }
            }
          },
          {
            title: '姓名',
            key: 'account',
            align: 'center',
            width: 80,
            fixed: 'left',
          },
          {
            title: '银行信息',
            key: 'name',
            minWidth: 150,
            render: (h, params) => {
              const record = params.row;
              const ret = [
                h('div', record.cur_bank || '未填写银行'),
                // h('div', '支行: ' + (params.row.bank_branch || '---')),
                h('div', record.cur_bank_number || '未填写卡号')
              ];
              if (this.can_edit && this.hasBankInfoUpdated(params.row)) {
                ret.push(h('Ajaxbtn', {
                  props: {
                    url: Util.api.update_informal_wage_record_bank_info,
                    params: {
                      id: params.row.id
                    },
                    config: {
                      size: 'small',
                      shape: 'circle',
                      icon: 'md-refresh',
                      name: '更新',
                      processingName: '',
                      successedName: '',
                      failedName: '',
                    },
                  },
                  on: {
                    done: this.updateRecordCurBankInfo
                  }
                }))
              }
              return h('div', ret);
            }
          },
          // {
          //   title: ' ',
          //   key: 'test_t',
          //   width: 120,
          //   render(h, params) {
          //     const record = params.row;
          //     const ret = []
          //     if (Number(record.work_days) > _this.wages_days) {
          //       ret.push(h('p', {
          //         class: 'color-error',
          //         style:{
          //           padding: '0px',
          //           margin: '0px'
          //         }
          //       }, `[记薪天数不能超过当月自然日天数(${_this.wages_days}天)]`))
          //     }
          //     if (Number(record.subsidy_days) > _this.wages_days) {
          //       ret.push(h('p', {
          //         class: 'color-error',
          //         style:{
          //           padding: '0px',
          //           margin: '0px'
          //         }
          //       }, `[餐补天数不能超过当月自然日天数(${_this.wages_days}天)]`))
          //     }
          //     return h('div', {}, ret)
          //   }
          // },
          // {
          //   title: '应打卡天数',
          //   key: 'should_clock_days',
          //   align: 'center',
          //   width: 110,
          // },
          {
            title: '税前日薪',
            key: 'cur_daily_wage',
            align: 'center',
            width: 60,
            render: (h, params) => {
              const record = params.row;
              const ret = [];
              if (record.cur_daily_wage) {
                ret.push(h('span', '￥' + record.cur_daily_wage));
              } else {
                ret.push(h('span', '无 '));
              }
              if (this.can_edit && this.hasDailyWageUpdated(params.row)) {
                ret.push(h('Ajaxbtn', {
                  props: {
                    url: Util.api.update_informal_wage_record_cur_daily_wage,
                    params: {
                      id: params.row.id
                    },
                    config: {
                      size: 'small',
                      shape: 'circle',
                      icon: 'md-refresh',
                      name: '更新',
                      processingName: '',
                      successedName: '',
                      failedName: '',
                    },
                  },
                  on: {
                    done: this.updateRecordCurDailyWage
                  }
                }))
              }
              return h('div', ret);
            }
          },
          {
            title: '每日餐补',
            key: 'cur_daily_subsidy',
            align: 'center',
            width: 80,
            render: (h, params) => {
              const record = params.row;
              const ret = [];
              if (record.cur_daily_subsidy) {
                ret.push(h('span', '￥' + record.cur_daily_subsidy));
              } else {
                ret.push(h('span', '无 '));
              }
              return h('div', ret);
            }
          },
          {
            //   title: '计薪天数（远程+现场）',
            renderHeader(h) {
              return h('div', {}, [h('div', {}, '计薪天数'), h('div', {}, '（远程+现场）')])
            },
            key: 'work_days',
            align: 'center',
            width: 100,
            render: this.daysRender({dis_key:'work_days' })
          },
          {
            title: '餐补天数',
            key: 'subsidy_days',
            align: 'center',
            width: 90,
            render: this.daysRender({dis_key:'subsidy_days'})
          },
          // {
          //     title: '计件工资(￥)',
          //     key: 'piece_rate_wage',
          //     align: 'center',
          //     width: 100,
          //     render: (h, params)=>{
          //         let ret = [];
          //         if(!this.can_edit){
          //             ret.push( h('span', ' ' + this.$util.formatPrice(params.row.piece_rate_wage)) );
          //         }else{
          //             ret.push( h('input', {
          //                 attrs: {
          //                     type: 'number',
          //                     size: 'small',
          //                 },
          //                 style: {
          //                     width: '80px',
          //                 },
          //                 'class': {
          //                     'input-form': true,
          //                 },
          //                 domProps: {
          //                     value: params.row.piece_rate_wage
          //                 },
          //                 on: {
          //                     blur: (event) => {
          //                         this.records[params.index].piece_rate_wage = event.target.value * 1;
          //                         this.saveRecords();
          //                     },
          //                     mousewheel: (event) => {
          //                         event.stopPropagation();
          //                         event.preventDefault();
          //                         return false;
          //                     }
          //                 }
          //             }) );
          //         }
          //         return h('div', ret);
          //     }
          // },
          {
            title: '奖金(￥)',
            key: 'bonus',
            align: 'center',
            width: 100,
            render: (h, params) => {
              const ret = [];
              if (!this.can_edit || params.row.dimission || params.row.team_change_flag) {
                ret.push(h('span', ' ' + this.$util.formatPrice(params.row.bonus)));
              } else {
                ret.push(h('input', {
                  attrs: {
                    type: 'number',
                    size: 'small',
                  },
                  style: {
                    width: '80px'
                  },
                  'class': {
                    'input-form': true,
                  },
                  domProps: {
                    value: params.row.bonus
                  },
                  on: {
                    blur: (event) => {
                      this.records[params.index].bonus = event.target.value * 1;
                      this.saveRecords();
                    },
                    mousewheel: (event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      return false;
                    }
                  }
                }));
              }
              return h('div', ret);
            }
          },
          {
            title: '提成(￥)',
            key: 'commission',
            align: 'center',
            width: 100,
            render: (h, params) => {
              const ret = [];
              if (!this.can_edit || params.row.dimission || params.row.team_change_flag) {
                ret.push(h('span', ' ' + this.$util.formatPrice(params.row.commission)));
              } else {
                ret.push(h('input', {
                  attrs: {
                    type: 'number',
                    size: 'small',
                  },
                  style: {
                    width: '80px'
                  },
                  'class': {
                    'input-form': true,
                  },
                  domProps: {
                    value: params.row.commission
                  },
                  on: {
                    blur: (event) => {
                      this.records[params.index].commission = event.target.value * 1;
                      this.saveRecords();
                    },
                    mousewheel: (event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      return false;
                    }
                  }
                }));
              }
              return h('div', ret);
            }
          },
          {
            title: '扣除(￥)',
            key: 'deductions',
            align: 'center',
            width: 100,
            render: (h, params) => {
              const ret = [];
              if (!this.can_edit || params.row.dimission || params.row.team_change_flag) {
                ret.push(h('span', ' ' + this.$util.formatPrice(params.row.deductions)));
              } else {
                ret.push(h('input', {
                  attrs: {
                    type: 'number',
                    size: 'small',
                  },
                  style: {
                    width: '80px'
                  },
                  'class': {
                    'input-form': true,
                  },
                  domProps: {
                    value: params.row.deductions
                  },
                  on: {
                    blur: (event) => {
                      this.records[params.index].deductions = event.target.value * 1;
                      this.saveRecords();
                    },
                    mousewheel: (event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      return false;
                    }
                  }
                }));
              }
              return h('div', ret);
            }
          },
          {
            renderHeader:(h) => {
              return h('span', ['其他发放(￥)', h('Tooltip', {
                props: {
                  content:"填写前请补充备注！",
                  placement:"top"
                }
              }, [h('Icon', {
                props: {
                  type:'md-help-circle',
                  size:14
                }
              })])])
            },
            title: '其他发放(￥)',
            key: 'other_bonus',
            align: 'center',
            width: 120,
            render: (h, params) => {
              const ret = [];
              if (!this.can_edit || params.row.dimission || params.row.team_change_flag) {
                ret.push(h('span', ' ' + this.$util.formatPrice(params.row.other_bonus)));
              } else {
                ret.push(h('input', {
                  attrs: {
                    type: 'number',
                    size: 'small',
                  },
                  style: {
                    width: '80px'
                  },
                  'class': {
                    'input-form': true,
                  },
                  domProps: {
                    value: params.row.other_bonus
                  },
                  on: {
                    blur: (event) => {
                      this.records[params.index].other_bonus = event.target.value * 1;
                      this.saveRecords();
                    },
                    mousewheel: (event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      return false;
                    }
                  }
                }));
              }
              return h('div', ret);
            }
          },
          {
            title: '税前工资',
            key: 'total_wage',
            align: 'center',
            width: 80,
            render: (h, params) => {
              // const record = params.row;
              // if (record.dimission) {
              //   return h('span', '￥' + this.$util.formatDecimal(params.row.pre_tax_wage));
              // }
              // const total = this.getPreTaxWage(record); 
              return h('span', '￥' + this.$util.formatDecimal(params.row.pre_tax_wage));
            }
          },
          /*{
                        title: '税后实收',
                        key: 'total_wage',
                        align: 'center',
                        width: 80,
                        render: (h, params)=>{
                            const record = params.row;
                            return h('span', '￥' + this.$util.formatPrice(record.total_wage));
                        }
                    },*/
          /*   {
                        title: '个人所得税',
                        key: 'tax',
                        align: 'center',
                        width: 90,
                        render: (h, params)=>{
                            const record = params.row;
                            return h('span', '￥' + this.$util.formatPrice(record.tax));
                        }
                    }, */
          {
            title: '操作',
            key: 'action',
            align: 'center',
            fixed: 'right',
            width: 150,
            render: (h, params) => {
              if (this.can_edit && params.row.team_change_flag && !this.is_reissue) {
                return h('div', [
                  h('Button', {
                    props: {
                      size: 'small'
                    },
                    on: {
                      click: () => {
                        this.editSalaryDetail(params.row, params.index);
                      }
                    }
                  }, '明细'),
                  h('Button', {
                    props: {
                      size: 'small'
                    },
                    on: {
                      click: () => {
                        this.deleteRecord(params.row, params.index);
                      }
                    }
                  }, '删除'),
                  h('span', ' '),
                  h('Button', {
                    props: {
                      size: 'small'
                    },
                    on: {
                      click: () => {
                        this.remarkRecord(params.row, params.index);
                      }
                    }
                  }, '备注')
                ]);
              } else if (this.can_edit && !params.row.team_change_flag) {
                return h('div', [
                  h('Button', {
                    props: {
                      size: 'small'
                    },
                    on: {
                      click: () => {
                        this.deleteRecord(params.row, params.index);
                      }
                    }
                  }, '删除'),
                  h('span', ' '),
                  h('Button', {
                    props: {
                      size: 'small'
                    },
                    on: {
                      click: () => {
                        this.remarkRecord(params.row, params.index);
                      }
                    }
                  }, '备注')
                ]);
              } else {
                return h('span', {}, '-');
              }
            }
          },
        ]
      },
      informals_computed() {
        let arr = this.informals
        if (this.status_type === 2) {
          arr = arr.filter(item => item.quit)
        }
        if (this.status_type === 1) {
          arr = arr.filter(item => !item.quit)
        }
        if (this.add_type === 1) {
          arr = arr.filter(item => this.isInRecords(item))
        }
        if (this.add_type === 2) {
          arr = arr.filter(item => !this.isInRecords(item))
        }
        return arr
      },
      informal_columns() {
        const _this = this
        return [
          {
            title: '工号',
            key: 'uid',
            align: 'center',
            fixed: 'left',
            width: 80,
            render: (h, params) => {
              return h('div', params.row.uid);
            }
          },
          {
            title: '姓名',
            key: 'account',
            align: 'center',
            fixed: 'left',
            width: 80,
            render: (h, params) => {
              return h('div', {
                'class': {
                  'color-error': params.row.quit
                }
              }, params.row.account);
            }
          },
          {
            title: '岗位',
            key: 'job',
            align: 'center',
            width: 100
          },
          {
            title: '状态',
            key: '',
            align: 'center',
            width: 150,
            renderHeader:(h, {column} = {}) => {
           
              return h('div', {}, [
                column.title,
                h('div', {
                  style: {
                    display: 'inline-block'
                  }
                }, [
                  h('Select', {
                    props: {
                      value: _this.status_type
                    },
                    style: {
                      display: 'inline-block',
                      marginLeft: '5px'
                    },
                    on: {
                      'on-change':(val) => {
                        _this.status_type = val
                      }
                    }
                  }, [
                    h('Option', {
                      props: {
                        value: 3
                      }
                    }, '全部'),
                    h('Option', {
                      props: {
                        value: 1
                      }
                    }, '在职'),
                    h('Option', {
                      props: {
                        value: 2
                      }
                    }, '离职'),
                  ])
                ])
              ])
            },
            render: (h, params) => {
              const customer = params.row;
              if (customer.quit) {
                return h('div', {
                  'class': {
                    'color-error': true
                  }
                }, '离职');
                /*return h('div', [
                                    h('div', {
                                        'class': {
                                            'color-error': customer.quit_time
                                        }
                                    }, '离职时间:'),
                                    h('div', {
                                        'class': {
                                            'color-error': customer.quit_time
                                        }
                                    }, customer.quit_time)
                                ]);*/
              } else {
                return h('div', {
                  'class': {
                    'color-success': true
                  }
                }, '在职');
              }
            }
          },
          {
            title: '银行信息',
            key: 'bank_info',
            width: 200,
            render: (h, params) => {
              const ret = [
                h('div', '银行: ' + (params.row.bank || '---')),
                // h('div', '支行: ' + (params.row.bank_branch || '---')),
                h('div', '卡号: ' + (params.row.bank_number || '---')),
                //                                h('div', '支付宝: ' + (params.row.alipay || '---')),
              ];
              if (!params.row.bank || !params.row.bank_number) {
                ret.push(h('div', {
                  'class': {
                    'color-error': true
                  }
                }, '请补全支付信息'));
              }
              return ret;
            }
          },
          {
            title: '考勤概述',
            key: 'r_k',
            minWidth: 240,
            render(h, params) {
              const row = params.row
              const hash = _this.attendance_list_hash
              const info = (hash[row.id] || {}).info
              return h('span', {}, [info, h('Button', {
                props: {
                  type: 'text',
                  size: 'small'
                },
                style: {
                  margin: '0 5px',
                  color: 'rgb(45, 140, 240)'
                },
                on: {
                  click: () => {
                    _this.attendance_type = row.id
                    _this.showAttendanceDetail(row);
                  }
                }
              }, '查看详情')])
            }
          },
          // {
          //     title: '支付宝',
          //     key: 'alipay',
          //     width: 150
          // },
          {
            title: '税前日薪',
            key: 'daily_wage',
            width: 80,
            align: 'center',
            render: (h, params) => {
              const informal = params.row;
              const ret = [];
              if (informal.daily_wage) {
                ret.push(h('Icon', {
                  props: {
                    type: 'logo-yen'
                  }
                }));
                ret.push(h('span', ' ' + Math.floor(informal.daily_wage) + ' '));
              } else {
                ret.push(h('span', '无 '));
              }
              return h('div', ret);
            }
          },
          {
            title: '操作',
            key: 'action',
            align: 'center',
            fixed: 'right',
            width: 120,
            renderHeader:(h, {column} = {}) => {
           
              return h('div', {}, [
                column.title,
                h('div', {
                  style: {
                    display: 'inline-block'
                  }
                }, [
                  h('Select', {
                    props: {
                      value: _this.add_type
                    },
                    style: {
                      display: 'inline-block',
                      marginLeft: '5px'
                    },
                    on: {
                      'on-change':(val) => {
                        _this.add_type = val
                      }
                    }
                  }, [
                    h('Option', {
                      props: {
                        value: 3
                      }
                    }, '全部'),
                    h('Option', {
                      props: {
                        value: 1
                      }
                    }, '已添加'),
                    h('Option', {
                      props: {
                        value: 2
                      }
                    }, '未添加'),
                  ])
                ])
              ])
            },
            render: (h, params) => {
              const row = params.row;
              const ret = [
                // h('Button', {
                //   props: {
                //     type: 'primary',
                //     size: 'small',
                //   },
                //   style:{
                //     marginRight: '5px'
                //   },
                //   on: {
                //     click: () => {
                //       this.attendance_type = row.id
                //       this.proxyGetAttendanceData([row.id]);
                //     }
                //   }
                // }, ['考勤'])
              ]
              if (this.isInRecords(params.row)) {
                ret.push(h('span', {}, '已添加'))
              } else {
                if (this.can_edit) {
                  ret.push(h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      loading: this.adding && this.adding_customer_id === row.id
                    },
                    on: {
                      click: () => {
                        if (!this.attendance_list || !this.attendance_list.length) {
                          this.$vModal.confirm({
                            title:'提示',
                            content:'尚未获取到考勤数据！',
                            onOk:() => {
                              // this.addCustomerToWageRecords(params.row);
                            }
                          })
                          return 
                        }
                        this.addCustomerToWageRecords(params.row);
                      }
                    }
                  }, '添加'))
                
                }
              }
              return h('div', ret)
            }
          },
        ]
      },
      attendance_list_hash() {
        if (!this.attendance_list || !this.attendance_list.length) {
          return {}
        }
        return this.attendance_list.reduce((total, item) => {
          total[item.customer_id] = item
          return total
        }, {})
      },
      attendance_list_proxy() {
        if (!this.attendance_type) {
          return []
        }
        if (this.attendance_type === 'all') {
          return this.attendance_list
        }
        return this.attendance_list.filter(item => item.customer_id === this.attendance_type)
      },
      wages_days() {
        if (!this.topic || !this.topic.wage_start) {
          return null
        }
        const day = moment(this.topic.wage_end).diff(moment(this.topic.wage_start), 'day')
        return Number(day) + 1
      },
      is_mint_team() {
        // 是否是薄荷团队的成员, 只有薄荷团队可以导入工资信息
        return this.cur_customer && this.cur_customer.root_team_id === 1;
      },
      // todo 是否可以随意选择员工, 仅临时用于选择暑期实习生, 需废弃相关逻辑
      can_select_user() {
        return [202, 2617].includes(this.cur_customer.id);
      },
      records_hash() {
        const hash = {};
        this.records.forEach((record) => {
          hash[record.customer_id] = record;
        });
        return hash;
      },
      informals_hash() {
        const hash = {};
        this.informals.forEach((informal) => {
          hash[informal.id] = informal;
        });
        return hash;
      },
      quit_count() {
        let count = 0;
        this.informals.forEach((informal) => {
          if (informal.quit) {
            count++;
          }
        });
        return count;
      },
      is_topic_finished() {
        return this.topic.status === 5;
      },
      director_topic_editing() {
        return this.director_topic.status === 1;
      },
      director_topic_returned() {
        return this.director_topic.status === 2;
      },
      director_topic_submitted() {
        return this.director_topic.status === 3;
      },
      director_topic_passed() {
        return this.director_topic.status === 5;
      },
      show_del_btn() {
        return this.records.length === 0 && this.director_topic.id && !this.director_topic.del;
      },
      can_edit() {
        // return !this.is_topic_finished && (this.director_topic_editing || this.director_topic_returned);
        return !this.is_topic_finished && FlowUtil.inEditNode(this.director_topic);
      },
      save_params() {
        return {
          id: this.director_topic.id,
          topic_id: this.topic.id,
          records: this.records.filter(i => !i.dimission)
        }
      },
      submit_params() {
        return {
          topic_id: this.topic.id,
          id: this.director_topic.id,
          status: 3
        }
      },
      submit_config() {
        return {
          size: 'small',
          type: 'primary',
          name: '提交审核',
          successedName: '提交成功',
          failedName: '提交失败',
          confirm: true,
          checkCallback: this.submitCheck
        }
      },
      ...mapGetters({
        companies_hash: 'async/companies_hash',
        teams_hash: 'async/root_teams_hash',
        jobs_hash: 'async/jobs_hash',
      }),
    },
    created() {
      this.getInformals();
      this.getMyInformalWageRecordsByTopic();
      //window.records = this.records;
    },
    methods: {
      uploadFile() {
        const file = this.el.files[0]
     
        if (file
        //  && ['xlsx', 'csv', 'xls', 'excel', 'spreadsheetml.sheet'].some(item => {
        //   return file.type.includes(item)
        // })
        ) {
          const formData = new FormData();
          formData.append('datafile', file)
          formData.append('topic_id', this.topic.id)
          importBatchApi(formData).then(() => {
            this.getMyInformalWageRecordsByTopic()
          })
        
          return 
        } 
        // this.$Message.error('不支持该格式！')
      },
      importxz() {
        this.el = document.createElement('input')
        this.el.setAttribute('type', 'file')
        this.el.style.display = 'none'
        this.$refs.contain.appendChild(this.el)
        this.el.click()
        this.el.addEventListener('change', this.uploadFile)
      },
      exportTempt() {
        window.open(`/api/${director_informal_wage_topic_export_template}?topic_id=${this.topic.id}`, '__blank')
      },
      daysRender({dis_key, input_key = dis_key}) {
        return (h, params) => {
          if (this.is_reissue) {
            return h('input', {
              attrs: {
                type: 'number',
                size: 'small',
                min: '0',
                max: '31',
                value: params.row[dis_key]
              },
              'class': {
                'input-form': true,
              },
              // domProps: {
              //   value: params.row.work_days
              // },
              on: {
                blur: (event) => {
                  const days = event.target.value * 1;
                  this.records[params.index][input_key] = days;
                  this.saveRecords();
                },
                mousewheel: (event) => {
                  event.stopPropagation();
                  event.preventDefault();
                  return false;
                }
              }
            })
          }
          return h('div', this.$util.formatDecimal(params.row[dis_key]));
        }
      },
      closeEdit() {
        this.getMyInformalWageRecordsByTopic();
      },
      async ensureAttendanceBeforeAdd() {
        try {
          const attendance_list = await this.ensureFullAttendanceData()
          if (!attendance_list) {
            return false
          }
          if (this.is_reissue) {
            return true
          }
          if (!attendance_list.length) {
            this.$vModal.warning({
              title:'提示',
              content:'未获取到实习生考勤数据，暂不能一键添加！'
            })
            return false
          }
          const missing_attendance = this.informals_computed.filter(item => {
            return !this.isInRecords(item) &&
              !this.getRecordError(item).length &&
              !this.getCurrentLeaderAttendanceSummary(this.attendance_list_hash[item.id])
          })
          if (missing_attendance.length) {
            this.$vModal.warning({
              title:'提示',
              render:(h) => {
                return h('div', {}, [
                  h('div', {}, '以下实习生未获取到当前填写人的考勤记录，暂不能一键添加：'),
                  ...missing_attendance.map(item => h('div', {}, item.account))
                ])
              }
            })
            return false
          }
          return true
        } catch (e) {
          return false
        }
      },
      async addAllInternProxy() {
        if (!this.can_edit) {
          this.$vModal.error({
            title: '提示',
            content: '当前单据已被废弃！点击“恢复填写”按钮可重新填写'
          })
          return 
        }
        const ready = await this.ensureAttendanceBeforeAdd()
        if (!ready) {
          return
        }
        this.addAllIntern()
      },
      addAllIntern() {
       
      
        //this.isInRecords(params.row)
        const arr = []
        let error_list_all = []
        this.informals_computed.forEach(i => {
          const error_list = this.getRecordError(i)
          // 未添加且已check的条目
          if (!this.isInRecords(i) && !error_list.length) {
          
            arr.push(i)
          } else if (!this.isInRecords(i) && error_list.length) {// 未添加且check有问题的
            error_list_all = error_list_all.concat([i.account, ...error_list])
          }
          
        })
        if (error_list_all.length) {
          this.$vModal.error({
            title: '提示',
            render:(h) => {
              return h('div', {}, error_list_all.map(s => h('div', {}, s)))
            }
          })
          return 
        }
        if (arr.length === 0) {
          this.$vModal.warning({
            title:'提示',
            content: '列表中没有满足添加的实习生！'
          })
          return 
        }
        this.set_wage_loading = true
        setBatchAddCustomerApi({
          topic_id: this.topic.id,
          customer_ids: arr.map(i => i.id)
        }).then(({records = [], errors = []} = {}) => {
          const records_hash = this.records.reduce((t, i) => {
            t[i.id] = i
            return t
          }, {})
          const new_arr = []
          records.forEach(item => {
            if (!records_hash[item.id]) {
              new_arr.push(item)
            }
          })
          this.records = this.records.concat(new_arr)
          this.$nextTick(() => {
            this.getInformals()
            this.initSubmitTopAll(new_arr)
          })
          this.$Message.success(new_arr && `成功添加${new_arr.length}人`)
          if (errors && errors.length) {
            this.$vModal.error({
              title:'提示',
              render:(h) => {
                return h('div', {}, errors.map(s => h('div', {}, s)))
              }
            })
          }
        }).finally(() => {
          this.set_wage_loading = false
        })
      },
      initSubmitTopAll(arr) {
        if (!arr || arr.length === 0) {
          return 
        }
        const arr_hash = arr.reduce((t, i) => {
          t[i.customer_id] = i
          return t
        }, {})
        this.records.forEach(record => {
          // const cus_has = record.customer_id === customer_id && 
          //   this.attendance_list_hash && 
          //   this.attendance_list_hash[record.customer_id]
          const customer_id = record.customer_id
          const cus_has = arr_hash[customer_id] && this.attendance_list_hash && this.attendance_list_hash[customer_id]
          if (cus_has) {
            const attendance = this.attendance_list_hash[record.customer_id]
            const summary = this.getCurrentLeaderAttendanceSummary(attendance)
            if (summary) {
              if (!this.is_reissue) { // 补发不用自动填充
                record.subsidy_days = summary.subsidy_days
                record.work_days = summary.work_days
              }
              record.should_clock_days = summary.should_clock_days
            }
          }
        })
        this.saveRecords()
      },
      initSubmitTop(res) {
        const customer_id = res.customer_id
        //  const current_customer_kq = (this.attendance_list_hash || {})[customer_id] || {}
        this.records.forEach(record => {
          // 当前实习生的打卡信息
          const cus_has = record.customer_id === customer_id && 
            this.attendance_list_hash && 
            this.attendance_list_hash[record.customer_id]
          if (cus_has) {
            const attendance = this.attendance_list_hash[record.customer_id]
            // record.subsidy_days = attendance.meal_subsidy_days
            // record.work_days = attendance.wage_days
            const summary = this.getCurrentLeaderAttendanceSummary(attendance)
            if (summary) {
              if (!this.is_reissue) { // 补发不用自动填充
                record.subsidy_days = summary.subsidy_days
                record.work_days = summary.work_days
              }
              record.should_clock_days = summary.should_clock_days
            }

            // record.should_clock_days = attendance.should_clock_days
          }
          // if (record.customer_id === customer_id) {
          //   record.subsidy_days = current_customer_kq.meal_subsidy_days
          // }
        })
        this.saveRecords()
      },
      exportData() {
        this.$refs.DownloadTable.outputExcel()
      },
      getAllInformalIds() {
        return (this.informals || []).map(item => item.id)
      },
      hasAttendanceRecord(customer_id) {
        return !!(this.attendance_list_hash && this.attendance_list_hash[customer_id])
      },
      addAttendanceNumber(total, value) {
        return math.eval(`${total || 0}+${value || 0}`)
      },
      getCurrentLeaderSalaryList(attendance) {
        const leader_id = this.cur_customer && this.cur_customer.id
        if (!attendance || !attendance.salary_list || !leader_id) {
          return []
        }
        return attendance.salary_list.filter(salary => {
          return Number(salary.count_leader_id) === Number(leader_id)
        })
      },
      getCurrentLeaderAttendanceSummary(attendance) {
        const salary_list = this.getCurrentLeaderSalaryList(attendance)
        if (!salary_list.length) {
          return null
        }
        return salary_list.reduce((total, salary) => {
          const detail = salary.detail || {}
          total.subsidy_days = this.addAttendanceNumber(total.subsidy_days, detail.meal_subsidy_days)
          total.work_days = this.addAttendanceNumber(total.work_days, detail.wage_days)
          total.should_clock_days = this.addAttendanceNumber(total.should_clock_days, detail.should_clock_days)
          return total
        }, {
          subsidy_days: 0,
          work_days: 0,
          should_clock_days: 0,
        })
      },
      tryInitAttendanceData() {
        if (
          this.attendance_full_loaded ||
          !this.informals_loaded ||
          !this.topic_loaded
        ) {
          return Promise.resolve(this.attendance_list)
        }
        const cid_set = this.getAllInformalIds()
        if (!cid_set.length) {
          this.attendance_list = []
          this.attendance_full_loaded = true
          return Promise.resolve(this.attendance_list)
        }
        return this.fetchAttendanceData({
          cid_set,
          replace: true,
          markFullLoaded: true,
        })
      },
      ensureFullAttendanceData({force = false} = {}) {
        if (!this.informals_loaded || !this.topic_loaded) {
          this.$Message.warning('正在获取实习生和发放信息，请稍后再试')
          return Promise.resolve(null)
        }
        if (!force && this.attendance_full_loaded) {
          return Promise.resolve(this.attendance_list)
        }
        const cid_set = this.getAllInformalIds()
        if (!cid_set.length) {
          this.attendance_list = []
          this.attendance_full_loaded = true
          return Promise.resolve(this.attendance_list)
        }
        return this.fetchAttendanceData({
          cid_set,
          replace: true,
          force,
          markFullLoaded: true,
        })
      },
      refreshAllAttendanceData() {
        this.attendance_type = 'all'
        return this.ensureFullAttendanceData({force: true})
      },
      showAttendanceDetail(row) {
        this.attendance_type = row.id
        if (this.hasAttendanceRecord(row.id)) {
          return Promise.resolve(this.attendance_list)
        }
        return this.fetchAttendanceData({
          cid_set: [row.id],
          replace: false,
        })
      },
      proxyGetAttendanceData(cid_set = this.getAllInformalIds(), options = {}) {
        return this.fetchAttendanceData({
          cid_set,
          ...options,
        })
      },
      fetchAttendanceData({cid_set, force = false, replace = false, markFullLoaded = false} = {}) {
        cid_set = (cid_set || []).filter(Boolean)
        if (!cid_set.length) {
          return Promise.resolve(this.attendance_list)
        }
        if (!this.topic || !this.topic.wage_start || !this.topic.wage_end) {
          return Promise.resolve(null)
        }
        if (this.attendance_request) {
          return this.attendance_request
        }
        if (!force && markFullLoaded && this.attendance_full_loaded) {
          return Promise.resolve(this.attendance_list)
        }
        if (!force && !replace && cid_set.every(id => this.hasAttendanceRecord(id))) {
          return Promise.resolve(this.attendance_list)
        }
        this.get_cx_loading = true
        this.attendance_loading_text = '正在获取实习生考勤信息，请稍候...'
        const request = hr_http.post(hr_wxdata_financial_intern_salary_of_customer_new, {
          from_date: this.topic.wage_start, 
          to_date: this.topic.wage_end, 
          "is_desc": true,
          cid_set,
        //  "cid_set": this.informals.map(item => item.id)
        }).then(res => {
          // const res_clone = res
          if (!res || !this.informals) {
            return this.attendance_list
          }
          res = Array.isArray(res) ? res : []
          // 筛选当前团队的人员
          // res = filterData(res, this.cur_customer.root_team_id)
          // cur_customer
          const arr = []
          const res_hash = res.reduce((total, item) => {
            total[item.customer_id] = item
            return total
          }, {})
          // 筛选当前存在的实习生
          this.informals.forEach(item => {
            if (res_hash[item.id]) {
              arr.push(res_hash[item.id])
            }
          })
          //informals
          if (replace) {
            this.attendance_list = arr
          } else {
            const attendance_hash = this.attendance_list.reduce((total, item) => {
              total[item.customer_id] = item
              return total
            }, {})
            arr.forEach(item => {
              attendance_hash[item.customer_id] = item
            })
            this.attendance_list = this.informals.reduce((total, item) => {
              if (attendance_hash[item.id]) {
                total.push(attendance_hash[item.id])
              }
              return total
            }, [])
          }
          if (markFullLoaded) {
            this.attendance_full_loaded = true
          }
          return this.attendance_list
        }).finally(() => {
          this.attendance_request = null
          this.get_cx_loading = false
          this.attendance_loading_text = ''
        })
        this.attendance_request = request
        return request
      },
      resetInvoiceInput() {
        this.$refs.importInput.value = '';
      },
      importFocus() {
        this.resetInvoiceInput();
      },
      importInvoice() {
        const file_path = this.$refs.importInput.value;
        const path_arr = file_path.split('.');
        const extname = path_arr[path_arr.length - 1].toLowerCase();
        if (['xlsx'].indexOf(extname) === -1) {
          this.$Modal.warning({
            title: '提示',
            content: '请上传Excel文件(后缀名应为xlsx)'
          });
          return;
        }

        const file = this.$refs.importInput.files[0];
        const formData = new FormData();
        formData.append('datafile', file);
        const topic_id = this.topic.id.toString();
        formData.append('topic_id', topic_id);

        this.import_processing = true;
        Util.ajax({
          url: Util.api.import_informal_wage_records,
          method: 'post',
          data: formData,
          timeout: 120000,
          onUploadProgress: (e) => {
            const percent = e.loaded / e.total * 100;
            this.import_percent = percent < 0.1 ? 0.1 : percent;
          },
        }).then(function(response) {
          return response.data;
        }).then((data) => {
          this.import_processing = false;
          this.resetInvoiceInput();
          if (data.code === 1) {
            this.$Modal.success({
              title: '提示',
              content: '导入成功!'
            });
            this.getMyInformalWageRecordsByTopic();
          } else {
            this.$Modal.error({
              title: '提示',
              content: data.msg
            });
          }
        }).catch((e) => {
          this.import_processing = false;
          this.resetInvoiceInput();
          this.$Message.error(`上传失败!: ${e}`);
        });
      },
      getInformals() {
        if (!this.isInformalLoading) {
          this.isInformalLoading = true;
          //  this.informal_empty_tip = '获取数据中...';
          Util.ajax.get(Util.api.get_my_informal_path, {
            params: {
              topic_id: this.$route.params.id
            }
          }).then((response) => {
            return response.data;
          }).then((res) => {
            if (res.code === 1) {
              const data = res.data;
              this.handleData(data);
              this.informals_loaded = true
              this.tryInitAttendanceData()
            } else {
              this.$Modal.error({
                title: '错误',
                content: res.msg
              });
            }
          }).catch((e) => {
            this.isInformalLoading = false;
            // this.informal_empty_tip = '获取数据失败, 请刷新页面重试';
            console.log(e);
          });
        }
      },
      rowClassName(row) {
        // 废弃
        if (row.status === 7) {
          return 'color-error';
        }
        return '';
      },
      handleData(data = {}) {
        const informals = data.informals || []
        const quit_arr = []
        this.isInformalLoading = false;
        this.informals = [];
        this.directors_hash = data.directors;
        informals.forEach((informal) => {
          this.preHandleInformal(informal);
          if (informal.quit) {
            quit_arr.push(informal)
          } else {
            this.informals.push(informal) 
          }
        });
        quit_arr.forEach(item => {
          this.informals.push(item) 
        })
        if (informals.length === 0) {
          //  this.informal_empty_tip = '没有结果, 请重试!';
        }
      },
      preHandleInformal(informal) {
        informal.gender = informal.gender ? '男' : '女';
        informal.director = this.directors_hash[informal.director_id] || '-';
        informal._checked = true;
        informal._disabled = true;
      },
      saveDone(res) {
        this.$Message.success({content: '保存成功', duration: 0.5});
        this.records = res.records;
      },
      saveFail(e) {
        this.$Modal.error({
          title: '保存失败',
          content: e.message
        });
        this.getMyInformalWageRecordsByTopic()
      },
      beforeUpdateDirectorTopic() {
        this.$refs.saveBtn.doAjax();
      },
      updateDirectorTopic(data) {
        this.topic = data.topic;
        this.director_topic = data.director_topic;
        setTimeout(() => {
          this.$Message.success('提交成功!');
        }, 800);
      },
      getMyInformalWageRecordsByTopic() {
        if (!this.loading) {
          this.loading = true;
          // this.empty_tip = '获取数据中...';
          Util.ajax.get(Util.api.my_informal_wage_topic_record, {
            params: {
              topic_id: this.$route.params.id
            }
          }).then((response) => {
            return response.data;
          }).then((data) => {
            if (data.code === 1) {
              const info = data.info;
              this.topic = info.topic;
              this.director_topic = info.director_topic;
              this.records = [];
              info.records.forEach((record) => {
                this.records.push(record);
              });
              if (info.records.length === 0) {
                this.empty_tip = '暂无数据';
              }
              this.topic_loaded = true
              this.tryInitAttendanceData()
            } else {
              this.$Modal.error({
                title: '提示',
                content: data.msg
              });
              this.empty_tip = '获取数据失败, 请刷新页面重试！';
            //  this.empty_tip = '没有数据!';
            }
          
          }).catch((e) => {
            
            this.empty_tip = '获取数据失败, 请刷新页面重试';
            console.log(e);
          }).finally(() => {
            this.loading = false
          });
        }
      },
      getPreTaxWage(record) {
        return math.eval(`${record.cur_daily_wage} *(${record.work_days || 0}) +${record.cur_daily_subsidy || 0}*${record.subsidy_days || 0}+ ${record.bonus}-${record.deductions || 0}`).toFixed(2);
      },
      isInRecords(customer) {
        return this.records_hash[customer.id];
      },
      hasDailyWageUpdated(record) {
        const informal_hash = this.informals_hash[record.customer_id];
        if (informal_hash) {
          return informal_hash.daily_wage * 1 - record.cur_daily_wage * 1 !== 0;
        }
        return false;
      },
      hasBankInfoUpdated(record) {
        const informal_hash = this.informals_hash[record.customer_id];
        if (informal_hash) {
          return informal_hash.bank !== record.cur_bank || informal_hash.bank_number !== record.cur_bank_number;
        }
        return false;
      },
      getRecordError(customer) {
        const errors = []
        Object.keys(records_error).forEach(k => {
          if (!customer[k]) {
            errors.push(records_error[k])
          }
        })
        return errors
      },
      checkRecord(customer) {
        const errors = this.getRecordError(customer)
        if (errors.length) {
          this.$Modal.warning({
            title: '提示',
            content: errors.map(s => `<p>${s}</p>`).join('\n')
          });
          return false;
        }
        return true;
      },
      submitCheck() {
        const msg = '';
        // this.records.forEach((record) => {
        //   if (math.eval(`${this.getPreTaxWage(record)} <= 0`)) {
        //     msg += `<p>${record.account} 工资金额应大于 0.</p>`;
        //   }
        // });
        if (msg) {
          this.$Modal.warning({
            title: '提示',
            content: msg
          });
          return false;
        }
        return true;
      },
      saveRecords() {
        
        if (this.is_exceed_days || this.is_exceed_subsidy_days) {
          return 
        }
        this.$nextTick(() => {
          this.$refs.saveBtn.doAjax();
        })
      },
      addCustomerToWageRecords(customer) {
        const cus_has = this.attendance_list_hash && 
          this.attendance_list_hash[customer.id]
        if ((!cus_has) && (!this.is_reissue)) {
          this.$vModal.warning({title: '提示', content: '未获取到当前实习生的考勤数据！'})
          return 
        }
        const valid = this.checkRecord(customer) || true;
        if (valid) {
          if (this.adding) return;
          this.adding = true;
          this.adding_customer_id = customer.id;
          Util.ajax.post(Util.api.add_customer_to_wage_records, {
            topic_id: this.$route.params.id,
            customer_id: customer.id
          }).then((response) => {
            return response.data;
          }).then((res) => {
            if (res.code === 1) {
              this.records.push(res.data.record);
              this.director_topic = res.data.director_topic;
              this.$nextTick(() => {
                this.initSubmitTop(res.data.record)
              })
            } else {
              this.$Modal.warning({title: '提示', content: res.msg})
            }
          }).catch((e) => {
            this.$Modal.warning({title: '提示', content: e.message})
          }).finally(() => {
            this.adding = false;
            this.adding_customer_id = 0;
          });
        }
      },
      updateRecordCurDailyWage(record) {
        this.records_hash[record.customer_id].cur_daily_wage = record.cur_daily_wage;
      },
      updateRecordCurBankInfo(record) {
        const target_record = this.records_hash[record.customer_id];
        target_record.cur_bank = record.cur_bank;
        target_record.cur_bank_uid = record.cur_bank_uid;
        target_record.cur_bank_branch = record.cur_bank_branch;
        target_record.cur_bank_number = record.cur_bank_number;
      },
      errorModal(res) {
        this.$Modal.error({title: '提示', content: res.msg})
      },
      deleteRecord(record, index) {
        this.$Modal.confirm({
          title: '提示',
          content: `你确定要取消 ${record.account} 的工资发放吗?`,
          onOk: () => {
            if (!this.deleting) {
              this.deleting = true;
              Util.ajax.post(Util.api.del_wage_record, {
                id: record.id
              }).then((response) => {
                return response.data;
              }).then((res) => {
                if (res.code === 1) {
                  this.records.splice(index, 1);
                  this.director_topic = res.data.director_topic;
                  this.$Message.success('删除成功');
                } else {
                  setTimeout(() => {
                    this.errorModal(res)
                  }, 300)
                  // this.$Modal.error({title: '提示', content: res.msg})
                }
              }).catch((e) => {
                setTimeout(() => { this.errorModal({msg: e.message })}, 300)
                //  this.$Modal.error({title: '提示', content: e.message})
              }).finally(() => {
                this.deleting = false;
              });
            }
          }
        })
      },
      editSalaryDetail(record, index) {
        console.log(record, index)
        console.log(this.$refs.recordModal)
        this.$refs.recordModal.edit(record, this.attendance_list_hash, this.cur_customer)
      },
      getRecordById(id) {
        let target = null;
        const len = this.records.length;
        for (let i = 0; i < len; i++) {
          const record = this.records[i];
          if (record.id === id) {
            target = record;
            break;
          }
        }
        return target;
      },
      deleteDirectorTopic() {
        this.$Modal.confirm({
          title: '提示',
          content: `你确定要放弃工资发放吗?`,
          onOk: () => {
            if (!this.deleting) {
              this.deleting = true;
              this.$util.ajax.post(this.$util.api.delete_director_informal_wage_topic, {
                id: this.director_topic.id
              }).then((response) => {
                return response.data;
              }).then((res) => {
                if (res.code === 1) {
                  this.director_topic = res.data.director_topic;
                  this.$Message.success('操作成功');
                } else {
                  this.$Modal.error({title: '提示', content: res.msg})
                }
              }).catch((e) => {
                this.$Modal.error({title: '提示', content: e.message})
              }).finally(() => {
                this.deleting = false;
              });
            }
          }
        });
      },
      recoverDirectorTopic() {
        this.$Modal.confirm({
          title: '提示',
          content: `你确定要恢复工资发放吗?`,
          onOk: () => {
            if (!this.recovering) {
              this.recovering = true;
              this.$util.ajax.post(this.$util.api.recover_director_informal_wage_topic, {
                id: this.director_topic.id
              }).then((response) => {
                return response.data;
              }).then((res) => {
                if (res.code === 1) {
                  this.director_topic = res.data.director_topic;
                  this.$Message.success('恢复成功');
                } else {
                  setTimeout(() => {
                    this.$Modal.error({title: '提示', content: res.msg});
                  }, 500);
                }
              }).catch((e) => {
                setTimeout(() => {
                  this.$Modal.error({title: '提示', content: e.message})
                }, 500);
              }).finally(() => {
                this.recovering = false;
              });
            }
          }
        });
      },
      remarkRecord(record) {
        this.edit_record = this.getRecordById(record.id);
        if (this.edit_record) {
          this.rich_text_config.show = true;
          this.rich_text_config.title = `备注 ${record.account} 的工资记录`;
        } else {
          this.$Modal.error({
            title: 'error',
            content: `未找到可备注的记录(id:${record.id})`
          });
        }
      },
    }
  }
</script>
